import { LayoutHeaderMenuDropdownColumn } from "../../../../types";
import { headerMenuColumnVariant } from "./header-menu.variants";
import NextLink from "next/link";
import { slugify } from "../../../../util/text";
import { EventAction } from "../../../../config/events";
import { Text } from "../../../ui/text";
import HeaderMenuItemFeatured from "./header-menu-item-featured";

type HeaderMenuColumnProps = {
  theme: "dark" | "light";
  column: LayoutHeaderMenuDropdownColumn;
};

function HeaderMenuColumn({ theme, column }: HeaderMenuColumnProps) {
  const styles = headerMenuColumnVariant({ theme });

  return (
    <div className={styles.base()}>
      {!!column.title && (
        <Text size="body" weight="semibold" className={styles.title()}>
          {column.title}
        </Text>
      )}

      <ul className={styles.list()}>
        {column.items.map((item, i) => {
          const { title, link, openNewWindow, featured } = item;
          const slugifiedSectionName = slugify(`header_${title}`);

          if (featured) {
            return (
              <HeaderMenuItemFeatured
                theme={theme}
                item={item}
                key={`${title}-${i}`}
              />
            );
          }

          return (
            <li className={styles.item()} key={`${title}-${i}`}>
              <NextLink
                className={styles.link()}
                data-event-action={EventAction.WebsiteClick}
                data-event-label={slugifiedSectionName}
                href={link}
                tabIndex={0}
                target={openNewWindow ? "_blank" : "_self"}
                title={title}
              >
                {title}
              </NextLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default HeaderMenuColumn;
